import { useTranslate } from 'hooks/useTranslate';
import { FC } from 'react';
import { Modal } from 'react-bootstrap';

import { useBeneficiaryTenderOfferSelectorModal } from '../context/BeneficiaryTenderOfferSelectorModalContext';

const BeneficiaryTenderOfferSelectorModalHeader: FC = () => {
  const { t } = useTranslate();

  const { actions } = useBeneficiaryTenderOfferSelectorModal();

  return (
    <Modal.Header>
      <h5 className="modal-title">{t('AvailableOffers')}</h5>
      <a className="close cursor-pointer" onClick={actions.handleCloseModal}>
        <em className="icon ni ni-cross" />
      </a>
    </Modal.Header>
  );
};

export default BeneficiaryTenderOfferSelectorModalHeader;
